import styled from "styled-components";

export const AIServiceSettingsWrapper = styled.div`
 width: 100%;
  height: 100%;
`;

export const ContentWrapper = styled.div`
  // max-width: 1400px;
  margin: 26px auto;
  // width: 90%;
  padding: 0 20px;
  
  @media (max-width: 1200px) {
    width: 95%;
  }
  
  @media (max-width: 768px) {
    width: 100%;
    padding: 0 16px;
  }
`;